<template>
    <div class="container-fluid" style="max-height: 100%; height: 100%; overflow: auto; padding-top: 0px; padding-bottom:60px;">
        <div class="row justify-content-center">
            <div class="container-fluid mt-6">
                <div class="row d-flex align-items-center flex-column justify-content-center">
                    <div class="col-xl-6 text-center">
                        

                        <h1 >
                            Your pre-order can start now
                        </h1>
              <p>Please get in contact with your editorial assistant and choose a date to start your pre-order.
                <br><br>

                <router-link to="/#/artist/home" class="btn btn-pink my-2">To Dashboard</router-link>



              </p>



                    </div>
                </div>
            </div>
        </div>
    </div>
    </template>
    <script>
    import { mapGetters, mapState, mapMutations, mapActions } from 'vuex'
      import { Tooltip } from 'element-ui'
      export default {
        name: 's07',
        components: {
          [Tooltip.name]: Tooltip
        },
        methods: {
            allDataValidated: function () {
                
                this.$emit('allowProceed');
            },
        },
        computed: {
            ...mapGetters({
                currentAccount: 'currentAccount',
            }),
        },
        mounted(){
            this.$emit('denyProceed');
            this.allDataValidated();
        },
      };
    </script>